import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { interestAreas } from 'utils/constants';
import classNames from 'classnames';
import StartView from './StartView';
import FinishView from './FinishView';
import Queue from './Queue';
import styles from './styles.scss';

class Quiz extends PureComponent {
  state = {
    isQuizFinished: false,
    progress: 0,
    questionsQueue: [],
    isQuizStarted: false,
  };

  addType = (checked, value) => {
    this.setState((prevState) => ({
      progress: checked
        ? prevState.progress + 100 / interestAreas.length
        : prevState.progress - 100 / interestAreas.length,
      questionsQueue: checked
        ? prevState.questionsQueue.concat(value)
        : prevState.questionsQueue.filter((quiz) => quiz !== value),
    }));
  };

  startQuiz = () => {
    this.setState({
      isQuizStarted: true,
    });
  };

  finishQuiz = () => {
    this.setState({
      isQuizFinished: true,
    });
  };

  renderView() {
    const { isQuizFinished, isQuizStarted, questionsQueue } = this.state;

    if (isQuizFinished) {
      return <FinishView {...this.props} />;
    }

    if (isQuizStarted) {
      return (
        <Queue finishQuiz={this.finishQuiz} questionsQueue={questionsQueue} />
      );
    }

    return (
      <StartView
        questionsQueue={questionsQueue}
        addType={this.addType}
        startQuiz={this.startQuiz}
        areas={interestAreas}
      />
    );
  }

  render() {
    const {
      props: {
        document: {
          fields: { backgroundImage },
        },
      },
      state: { isQuizFinished },
    } = this;

    return (
      <div
        className={styles.quizBlock}
        style={{
          backgroundImage: `url(${get(
            backgroundImage,
            'backgroundImage.fields.file.url',
          )}?fm=webp)`,
        }}
      >
        <div
          className={classNames(styles.quizContainer, {
            [styles.fluid]: isQuizFinished,
          })}
        >
          {this.renderView()}
        </div>
      </div>
    );
  }
}

Quiz.propTypes = {
  document: PropTypes.object,
};

export default Quiz;
